export default __webpack_public_path__ + "static/media/28.7492d230.jpg";